import { useState } from "react";

import { ClinicalPanel, type ClinicalKind } from "@/components/clinical/clinical-panel";
import type { PersonDetail } from "@/api/db/people";
import { PessoaLabels } from "@/lib/labels";
import { cn } from "@/lib/utils";

import { FichaDocumentos } from "./ficha-documentos";

type FichaClinicoKind = ClinicalKind | "documentos";

const MEDICAL_KINDS: FichaClinicoKind[] = ["prontuario", "exames", "manual", "documentos"];
const STAFF_KINDS: FichaClinicoKind[] = ["documentos"];

export function FichaClinico({ person, isDoctor }: { person: PersonDetail; isDoctor: boolean }) {
	const [kind, setKind] = useState<FichaClinicoKind>(isDoctor ? "prontuario" : "documentos");

	const anchor = { patientId: person.id };
	const kinds = isDoctor ? MEDICAL_KINDS : STAFF_KINDS;

	return (
		<div data-component="ficha-clinico" data-kind={kind} className="flex flex-col gap-4">
			<nav className="flex flex-wrap items-center gap-1 border-b border-border">
				{kinds.map((value) => (
					<button
						key={value}
						type="button"
						data-slot="clinical-kind"
						data-kind={value}
						aria-current={value === kind ? "page" : "false"}
						onClick={() => setKind(value)}
						className={cn(
							"border-b-2 px-3 py-2 text-sm font-medium transition-colors",
							value === kind
								? "border-primary text-foreground"
								: "border-transparent text-muted-foreground hover:text-foreground",
						)}
					>
						{PessoaLabels.clinicalKind[value]}
					</button>
				))}
			</nav>

			{kind === "documentos" && <FichaDocumentos person={person} />}
			{kind !== "documentos" && <ClinicalPanel kind={kind} anchor={anchor} />}
		</div>
	);
}
